<template>
    <div>
        <!-- Slot Search -->
        <div class="mb-1 ml-2 mr-2">
            <slot></slot>
        </div>
        <!--  -->
        <div v-if="loadingApp == false">
            <div v-if="data.data.length > 0">
                <ul class="listview image-listview-product full ml-0 mr-0">
                    <li v-for="item in this.data.data" :key="item.id">
                        <div class="item pl-2 pr-3 pt-2 pb-2">
                            <div class="in">
                                <div style="width: 90%;">
                                    <header>
                                        {{ createdAt(item.created_at) }}
                                    </header>
                                    <h4 class="text-secondary">
                                        {{ item.points_description }}
                                    </h4>
                                    <footer>
                                        <b>Hangus pada</b>
                                        {{ expiryDate(item.expiry_date) }}
                                    </footer>
                                </div>
                                <span
                                    class="text-muted text-right"
                                    style="line-height: 10px;"
                                >
                                    <!-- <small>ID#{{ item.id }}</small> -->
                                    <h5
                                        class="mb-0 text-success"
                                        style="font-weight:bold;"
                                        v-if="item.points > 0"
                                    >
                                        +{{ item.points | rupiah }}
                                    </h5>
                                    <h5
                                        class="mb-0 text-secondary"
                                        style="font-weight:bold;"
                                        v-else
                                    >
                                        +{{ item.points | rupiah }}
                                    </h5>
                                    <small>points</small>
                                </span>
                            </div>
                        </div>
                    </li>
                </ul>
                <div
                    class="m-2 text-center"
                    v-if="data.next_page_url && data.to >= data.per_page"
                >
                    <ButtonLoader
                        :loading="loadingButton"
                        :styled="'btn btn-primary rounded mr-1 mb-1'"
                        @click.native="$emit('paginate')"
                        >Lihat lebih banyak</ButtonLoader
                    >
                </div>
            </div>
            <div class="text-center mt-5 mb-5" v-else>
                <img
                    :src="require('@/assets/image/empty.webp')"
                    alt="404"
                    class="w-75 mb-3"
                /><br />
                <h2 class="mb-0">Belum Ada Data</h2>
                <p>Tidak ada data yang dapat ditampilkan</p>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import moment from 'moment';
    moment.locale('id');
    export default {
        props: ['data', 'loadingButton', 'loadingApp'],
        computed: {
            ...mapState(['VUE_ENV']),
            groupByDate() {
                return this.groupBy(this.data.data, 'created_at');
            },
        },
        methods: {
            createdAt(date) {
                return moment(date).format('D MMM YYYY HH:mm');
            },
            expiryDate(date) {
                return moment(date).format('ll');
            },
            groupBy(array, key) {
                const result = {};
                array.forEach(item => {
                    let date = moment(item[key]).format('ll');
                    if (!result[date]) {
                        result[date] = [];
                    }
                    result[date].push(item);
                });
                return result;
            },
        },
    };
</script>
